import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

export default class ToggleSwitch extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    onChange: PropTypes.func,
    checked: PropTypes.bool
  };

  state = {
    checked: this.props.checked
  };

  onChange = e => {
    this.setState({ checked: e.target.checked });
    this.props.onChange(e);
  };

  render() {
    return (
      <div className={'toggle-switch'}>
        <input
          type='checkbox'
          name={this.props.name}
          className='toggle-switch-checkbox'
          id={this.props.id}
          checked={this.props.checked}
          onChange={this.onChange}
        />
        <label className='toggle-switch-label' htmlFor={this.props.id}>
          <span className={ 'toggle-switch-inner' } data-yes data-no/>
          <span className={ 'toggle-switch-switch' }/>
        </label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/toggle_switch/index.jsx